import { useTranslation } from 'react-i18next';
import { useLegacyMessaging } from '@/shared/lib/legacyMagic';
import { AsyncActionButton } from '@/shared/ui';

interface PublishButtonProps {
  productId: number;
  destinationSeasonId: number;
  termsSerialId: number;
  disabled?: boolean;
}

export function PublishButton({
  productId,
  destinationSeasonId,
  termsSerialId,
  disabled,
}: PublishButtonProps) {
  const { t } = useTranslation('columbus-planner');
  const { send, isPending } = useLegacyMessaging();

  const handlePublish = () => {
    send(
      'columbus-planner/message',
      { productId, destinationSeasonId, termsSerialId, action: 'publish' },
      () => {}
    );
  };

  return (
    <AsyncActionButton
      isRunning={isPending}
      onClick={handlePublish}
      runningLabel={t('detail.publishing')}
      doneLabel={t('detail.published')}
      disabled={disabled}
      className="border-phx-primary text-phx-primary hover:bg-phx-primary-tint disabled:cursor-not-allowed disabled:opacity-50"
    >
      {t('detail.publish')}
    </AsyncActionButton>
  );
}
